// light gray
export const LIGHT = {
    25: '#FFFFFF',
    50: '#F9FAFC',
    100: '#F5F6F8',
    200: '#EDEFF3',
    300: '#DADCE0',
    400: '#B7B7BD',
    500: '#8E8E93',
    600: '#656569',
    700: '#464646',
    800: '#222222',
    900: '#000000',
};
// dark gray
export const DARK = {
    25: '#1B1B1C',
    50: '#252526',
    100: '#343435',
    200: '#3C3C3E',
    300: '#4D4D50',
    400: '#6B6B6E',
    500: '#8E8E93',
    600: '#B7B7BD',
    700: '#D3D3D9',
    800: '#E9E9EF',
    900: '#FFFFFF',
};
export const NEW_BRAND_BLUE = {
    100: '#EFEFFF',
    200: '#E7E6FF',
    300: '#D8D6FF',
    400: '#B8B5FF',
    500: '#9691FF',
    600: '#837DFD',
    700: '#716AF9',
    800: '#6159F4',
    900: '#564EF5',
    1000: '#453DEB',
    1100: '#3E36CD',
    1200: '#312ABE',
    1300: '#1E1896',
    1400: '#0B066A',
};
export const NEW_BRAND_GREEN = {
    100: '#FBFFF5',
    200: '#F9FFF0',
    300: '#F8FFEE',
    400: '#F6FFE8',
    500: '#F4FFE4',
    600: '#F0FFDB',
    700: '#ECFFD2',
    800: '#E7FDC7',
    900: '#E3FFBC',
    1000: '#D5F7A5',
    1100: '#C2F17F',
    1200: '#AFE85E',
    1300: '#99D83F',
    1400: '#81C028',
};
// green
export const SUCCESS = {
    100: '#CEF8E0',
    200: '#ADF4CE',
    300: '#89ECBC',
    400: '#67DEA8',
    500: '#49CC93',
    600: '#2FB880',
    700: '#15A46E',
    800: '#008F5D',
    900: '#007A4D',
    1000: '#00653E',
    1100: '#005132',
    1200: '#053F27',
    1300: '#0A2E1D',
    1400: '#0A2015',
};
// orange
export const WARNING = {
    100: '#FFECCC',
    200: '#FFDFAD',
    300: '#FDD291',
    400: '#FFBB63',
    500: '#FFA037',
    600: '#F68511',
    700: '#E46F00',
    800: '#CB5D00',
    900: '#B14C00',
    1000: '#953D00',
    1100: '#7A2F00',
    1200: '#612300',
    1300: '#491901',
    1400: '#351201',
};
// red
export const DANGER = {
    100: '#FFEBE7',
    200: '#FFDDD6',
    300: '#FFCDC3',
    400: '#FFB7A9',
    500: '#FF9B88',
    600: '#FF7C65',
    700: '#F75C46',
    800: '#EA3829',
    900: '#D31510',
    1000: '#B40000',
    1100: '#930000',
    1200: '#740000',
    1300: '#590000',
    1400: '#430000',
};
// blue
export const NEUTRAL = {
    100: '#E0F2FF',
    200: '#CAE8FF',
    300: '#B5DEFF',
    400: '#96CEFD',
    500: '#78BBFA',
    600: '#59A7F6',
    700: '#3892F3',
    800: '#147AF3',
    900: '#0265DC',
    1000: '#0054B6',
    1100: '#004491',
    1200: '#003571',
    1300: '#002754',
    1400: '#001C3C',
};
export const PINK_GOLD_GRADIENT = 'linear-gradient(262deg, #D2BD8D 11.82%, #ED9BE3 59.68%)';
export const PURPLE_BLUE_GRADIENT = 'linear-gradient(261deg, #449CFB 0%, #A291FB 48.39%, #F187FB 100%)';
export const TRANSPARENT = 'transparent';
